<template>
  <div>
    <el-dialog :visible.sync='visible' v-bind='$attrs' v-on='$listeners' @open='onOpen' @close='onClose'
               :title='dialogTitle'
               append-to-body
               width='980px'>

      <div v-loading='loading' element-loading-text='加载中……'
           element-loading-spinner='el-icon-loading'>
        <el-tabs v-model='activeName' type='card'>

          <el-tab-pane :label='column.name' :name='key' v-for='(column,key) in columnMap'
                       :key='key'>
            <ColSettingTable :table-data.sync='column.columns'></ColSettingTable>
          </el-tab-pane>
        </el-tabs>

      </div>
      <div style='text-align: center;padding: 10px'>
        <el-button v-if='Object.keys(columnMap).length===0' type='warning' size='medium' :disabled='loadingCommit'
                   :loading='loadingCommit'
                   @click='handleInit()'>
          初始化
        </el-button>
        <el-button v-else type='primary' size='medium' :disabled='loadingCommit' :loading='loadingCommit'
                   @click='onsubmit()'>
          保存
        </el-button>
        <el-button style='float: right;display: none' round size='medium' @click='handleCopy()'>
          复制配置
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import { getColsBasicRecords, saveColsBasicRecords } from '@/api/kol_basic_record'
import { columnMap } from '../data.json'
import ColSettingTable from '@/pages/artist/base/modules/ColSettingTable.vue'

export default {
  name: 'ColSetting',
  components: { ColSettingTable },
  data() {
    return {
      dialogTitle: '列设置',
      visible: false,
      loading: false,
      loadingCommit: false,
      columnMap: {},
      activeName: ''
    }
  },
  methods: {
    show() {
      this.visible = true
      this.handleLoadCols()
    },
    onOpen() {

    },
    onClose() {
      this.$emit('closed')
    },
    close() {
      this.visible = false
      this.$emit('update:visible', false)
    },
    handleLoadCols() {
      this.loading = true
      getColsBasicRecords({}).then(({ data }) => {
        if (data && data.length > 0) {
          this.activeName = data[0]['platform_code'] || ''
          data.forEach((row) => {
            if (typeof row.content === 'string') {
              row.content = JSON.parse(row.content)
            }
            this.columnMap[row.platform_code] = row.content
          })
        }
        setTimeout(() => {
          this.loading = false
        }, 50)
      })
    },
    async handleSetCol() {
      const taskList = []
      Object.keys(this.columnMap).forEach((platform_code) => {
        taskList.push(saveColsBasicRecords({ platform_code: platform_code, content: this.columnMap[platform_code] }))
      })

      // eslint-disable-next-line no-unused-vars
      await Promise.all(taskList).then(_values => {
        // 所有Promise成功时的处理
        // console.log(_values)
        this.$emit('saved')
        this.close()
      }).catch(error => {
        // 第一个Promise失败时的处理
        // console.log(error)
      })
    },
    onsubmit() {
      this.handleSetCol()
    },
    handleRemove(row) {
      const pIndex = this.columnMap[this.activeName]['columns'].findIndex(value => value.prop === row.prop)
      this.columnMap[this.activeName]['columns'].splice(pIndex, 1)
    },
    async handleInit() {
      const taskList = []
      Object.keys(columnMap).forEach((platform_code) => {
        taskList.push(saveColsBasicRecords({ platform_code: platform_code, content: columnMap[platform_code] }))
      })

      // eslint-disable-next-line no-unused-vars
      await Promise.all(taskList).then(_values => {
        // 所有Promise成功时的处理
        // console.log(_values)
        this.$emit('saved')
        this.close()
      }).catch(error => {
        // 第一个Promise失败时的处理
        // console.log(error)
      })
    },
    handleCopy() {
      const val = JSON.stringify(this.columnMap)
      //复制到剪切板
      navigator.clipboard.writeText(val)
        .then(() => {
          this.msgSuccess('复制成功')
        }).catch(err => console.error('复制失败:', err))
    }

  }
}
</script>

<style scoped>
.setting-column__title {
  border-bottom: 1px solid #EBEEF5;
  padding-bottom: 15px;
}

.setting-column__title span {
  display: inline-block;
  font-weight: bold;
  color: #909399;
  font-size: 12px;
}

.setting-column__title span.move_b {
  width: 30px;
  margin-right: 15px;
}

.setting-column__title span.show_b {
  width: 60px;
}

.setting-column__title span.name_b {
  width: 160px;
  margin-right: 15px;
}

.setting-column__title span.width_b {
  width: 60px;
  margin-right: 15px;
}

.setting-column__title span.sortable_b {
  width: 60px;
}

.setting-column__title span.fixed_b {
  width: 60px;
}

.setting-column__list {
  max-height: 800px;
  overflow: auto;
}

.setting-column__list li {
  list-style: none;
  margin: 10px 0;
}

.setting-column__list li > span {
  display: inline-block;
  font-size: 12px;
}

.setting-column__list li span.move_b {
  width: 30px;
  margin-right: 15px;
}

.setting-column__list li span.show_b {
  width: 60px;
}

.setting-column__list li span.name_b {
  width: 160px;
  margin-right: 15px;
}

.setting-column__list li span.width_b {
  width: 60px;
  margin-right: 15px;
}

.setting-column__list li span.sortable_b {
  width: 60px;
}

.setting-column__list li span.fixed_b {
  width: 60px;
}

.setting-column__list li.ghost {
  opacity: 0.3;
}

.setting-column__bottom {
  border-top: 1px solid #EBEEF5;
  padding-top: 15px;
  text-align: right;
}

/*.dark .setting-column__title {*/
/*  border-color: var(--el-border-color-light);*/
/*}*/

/*.dark .setting-column__bottom {*/
/*  border-color: var(--el-border-color-light);*/
/*}*/
</style>
